import { ImportantNoticeCloseMode } from '../configs/type';
import config from '../package.json';
const ID = `${config.name}/actions/importantNoticeActions`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const RECORD_CLOSED_IMPORTANT_NOTICE = createActionName(
  'RECORD_CLOSED_IMPORTANT_NOTICE',
);

export const SET_CLOSED_IMPORTANT_NOTICE_LOCAL_STATE = createActionName(
  'SET_CLOSED_IMPORTANT_NOTICE_LOCAL_STATE',
);

export const closeImportNotice = (
  noticeId: string,
  closeMode: ImportantNoticeCloseMode,
) => {
  return {
    type: RECORD_CLOSED_IMPORTANT_NOTICE,
    payload: {
      noticeId: noticeId,
      closeMode: closeMode,
    },
  };
};
